// Copy for the Product Studio edit workspace (/admin/catalog/products/:id).
// Albanian is the primary language for shop staff; English mirrors it.
// Merged into the global translations under the `productStudioEdit` namespace.

const tx = (sq, en) => ({ sq, en });

const productStudioEditTranslations = {
  // ── Shell ────────────────────────────────────────────────
  back: tx("Kthehu te produktet", "Back to products"),
  idLabel: tx("ID", "ID"),
  copyId: tx("Kopjo ID-në", "Copy ID"),
  idCopied: tx("ID u kopjua.", "ID copied."),
  created: tx("Krijuar", "Created"),
  updated: tx("Përditësuar", "Updated"),
  viewInStore: tx("Shiko në dyqan", "View in store"),
  viewInStoreDisabled: tx(
    "Produkti nuk është i publikuar në dyqan, prandaj nuk ka faqe publike.",
    "The product is not published in the store, so it has no public page."
  ),
  moreActions: tx("Më shumë", "More"),
  moreAddStock: tx("Shto stok", "Add stock"),
  moreAdjustStock: tx("Rregullo stokun", "Adjust stock"),
  morePrintLabels: tx("Printo etiketat", "Print labels"),
  moreRefresh: tx("Rifresko të dhënat", "Refresh data"),
  saveChanges: tx("Ruaj ndryshimet", "Save changes"),
  saving: tx("Duke ruajtur…", "Saving…"),
  allSaved: tx("Të gjitha të ruajtura", "All changes saved"),
  loading: tx("Duke ngarkuar produktin…", "Loading product…"),
  loadErrorTitle: tx("Produkti nuk u ngarkua", "The product could not be loaded"),
  loadErrorCopy: tx(
    "Kontrollo lidhjen me internetin dhe provo përsëri. Nëse problemi vazhdon, produkti mund të mos ekzistojë më.",
    "Check your connection and try again. If the problem continues, the product may no longer exist."
  ),
  retry: tx("Provo përsëri", "Try again"),
  tabsAria: tx("Seksionet e produktit", "Product sections"),

  tabOverview: tx("Përmbledhje", "Overview"),
  tabMedia: tx("Imazhe", "Images"),
  tabVariants: tx("Variantet", "Variants"),
  tabStock: tx("Stok", "Stock"),
  tabDetails: tx("Detaje", "Details"),
  tabPublishing: tx("SEO & Publikimi", "SEO & Publishing"),
  tabHistory: tx("Historiku", "History"),

  // Status
  statusPublished: tx("Aktiv në dyqan", "Live in store"),
  statusPosOnly: tx("Aktiv vetëm në shitore", "Active in shop only"),
  statusDraft: tx("Draft", "Draft"),
  statusArchived: tx("Arkivuar", "Archived"),

  // Save bar
  unsavedTitle: tx("Ke ndryshime të paruajtura", "You have unsaved changes"),
  unsavedIn: tx("Në: {sections}", "In: {sections}"),
  discardChanges: tx("Anulo ndryshimet", "Discard changes"),
  discardConfirmTitle: tx("Të anulohen ndryshimet?", "Discard changes?"),
  discardConfirmCopy: tx(
    "Ndryshimet që nuk janë ruajtur do të humbasin dhe produkti do të kthehet siç është i ruajtur tani.",
    "Changes that have not been saved will be lost and the product will return to its saved state."
  ),
  discardConfirmAction: tx("Po, anuloji", "Yes, discard"),
  leaveConfirm: tx(
    "Ke ndryshime të paruajtura. Nëse largohesh, ato do të humbasin. Vazhdo?",
    "You have unsaved changes. They will be lost if you leave. Continue?"
  ),
  sectionCore: tx("Informacioni", "Information"),
  sectionPricing: tx("Çmimet", "Prices"),
  sectionVariants: tx("Variantet", "Variants"),
  sectionMedia: tx("Fotot", "Photos"),
  sectionStructure: tx("Struktura e varianteve", "Variant structure"),
  saveResultOk: tx("U ruajt: {sections}.", "Saved: {sections}."),
  saveResultFailed: tx(
    "Nuk u ruajt: {sections}. Ndryshimet e tyre janë ende këtu — provo përsëri.",
    "Not saved: {sections}. Their changes are still here — try again."
  ),
  structurePendingHint: tx(
    "Ndryshimet e strukturës ruhen veçmas te skeda Variantet.",
    "Structure changes are saved separately in the Variants tab."
  ),

  // Generic
  cancel: tx("Anulo", "Cancel"),
  close: tx("Mbyll", "Close"),
  done: tx("U krye", "Done"),
  edit: tx("Redakto", "Edit"),
  remove: tx("Hiq", "Remove"),
  optional: tx("opsionale", "optional"),
  none: tx("Asnjë", "None"),
  notSet: tx("Nuk është vendosur", "Not set"),
  all: tx("Të gjitha", "All"),
  unsavedChip: tx("I paruajtur", "Unsaved"),
  charCount: tx("{count}/{max}", "{count}/{max}"),
  noImage: tx("Pa foto", "No photo"),
  variantFallback: tx("Varianti #{id}", "Variant #{id}"),
  locationFallback: tx("Lokacioni #{id}", "Location #{id}"),
  systemActor: tx("Sistemi", "System"),
  showMore: tx("Shfaq më shumë", "Show more"),
  moveEarlier: tx("Lëviz para", "Move earlier"),
  moveLater: tx("Lëviz pas", "Move later"),

  // ── Overview ─────────────────────────────────────────────
  ovMainInfo: tx("Informacioni kryesor", "Main information"),
  ovName: tx("Emri i produktit", "Product name"),
  ovBrand: tx("Marka", "Brand"),
  ovCategory: tx("Kategoria", "Category"),
  ovType: tx("Lloji i produktit", "Product type"),
  ovPrice: tx("Çmimi", "Price"),
  ovCompareAt: tx("Çmimi krahasues", "Compare-at price"),
  ovCompareAtHint: tx(
    "Çmimi i vjetër që shfaqet i vizatuar kur ka zbritje.",
    "The old price shown struck through during a sale."
  ),
  ovCost: tx("Kosto", "Cost"),
  ovCostHint: tx("Nuk shfaqet për klientët.", "Never shown to customers."),
  ovPricingAppliesAll: tx(
    "Ndryshimi i çmimit këtu vendoset për të gjitha {count} variantet aktive.",
    "Changing a price here applies it to all {count} live variants."
  ),
  ovPricingMixed: tx(
    "Variantet kanë çmime të ndryshme ({range}). Nëse e ndryshon këtu, të gjitha do të marrin të njëjtin çmim.",
    "Variants have different prices ({range}). Changing it here gives them all the same price."
  ),
  ovMargin: tx("Fitimi për copë: {amount} ({percent})", "Profit per item: {amount} ({percent})"),
  ovShortDescription: tx("Përshkrimi i shkurtër", "Short description"),
  ovShortDescriptionHint: tx(
    "Shfaqet në faqen e produktit dhe në Meta Catalog.",
    "Shown on the product page and in the Meta Catalog."
  ),
  ovTechnical: tx("Të dhëna teknike", "Technical details"),
  ovBaseSku: tx("Kodi bazë i modelit (SKU)", "Model base code (SKU)"),
  ovBaseSkuHint: tx(
    "Përdoret vetëm kur krijohen variante të reja. SKU-të ekzistuese nuk ndryshojnë.",
    "Used only when new variants are created. Existing SKUs do not change."
  ),
  ovProductMode: tx("Struktura", "Structure"),
  ovModeVariant: tx("Me variante", "With variants"),
  ovModeSimple: tx("Pa variante", "No variants"),
  ovInventoryMode: tx("Ndjekja e stokut", "Stock tracking"),
  ovInventoryAggregate: tx("Sasi për lokacion", "Quantity per location"),
  ovInventorySerialized: tx("Njësi me barkod të veçantë", "Individually barcoded units"),
  ovSource: tx("Burimi", "Source"),
  ovSourceNative: tx("Krijuar në Product Studio", "Created in Product Studio"),
  ovSourceLegacy: tx("Importuar nga sistemi i vjetër", "Imported from the old system"),
  ovPhotoCount: tx("{count} foto", "{count} photos"),
  ovManagePhotos: tx("Menaxho fotot", "Manage photos"),
  ovStatusCard: tx("Statusi & publikimi", "Status & publishing"),
  ovInStore: tx("I publikuar në dyqan", "Published in store"),
  ovInPos: tx("Në dispozicion për shitje në shitore", "Available for in-store sale"),
  ovMetaCatalog: tx("Përfshirë në Meta Catalog", "Included in Meta Catalog"),
  ovYes: tx("Po", "Yes"),
  ovNo: tx("Jo", "No"),
  ovPublishedAt: tx("Publikuar më", "Published on"),
  ovManagePublishing: tx("Menaxho publikimin", "Manage publishing"),
  ovReadiness: tx("Gatishmëria e produktit", "Product readiness"),
  ovReadinessCopy: tx(
    "{done} nga {total} hapa të plotësuar",
    "{done} of {total} steps complete"
  ),
  ovVariantsStock: tx("Variantet & stoku", "Variants & stock"),
  ovManage: tx("Menaxho", "Manage"),
  ovVariants: tx("Variante", "Variants"),
  ovOnHand: tx("Në dorë", "On hand"),
  ovAvailable: tx("Në dispozicion", "Available"),
  ovReserved: tx("I rezervuar", "Reserved"),
  ovOutOfStock: tx("Pa stok", "Out of stock"),
  ovLowStock: tx("Stok i ulët", "Low stock"),
  ovWebshopDetails: tx("Detaje për webshop", "Webshop details"),
  ovWebshopEmpty: tx(
    "Ende nuk janë shtuar detaje për klientët (materiali, kujdesi, masat…).",
    "No customer details yet (material, care, sizing…)."
  ),
  ovQuickActions: tx("Veprime të shpejta", "Quick actions"),
  ovActionAddPhotos: tx("Shto foto", "Add photos"),
  ovActionAddStock: tx("Shto stok", "Add stock"),
  ovActionPrint: tx("Printo etiketat", "Print labels"),
  ovActionHistory: tx("Shiko historikun", "View history"),

  // Readiness steps (frontend checklist; blockers come from the server)
  readyTitle: tx("Emri", "Name"),
  readyPrice: tx("Çmimi për çdo variant", "A price on every variant"),
  readyPhotos: tx("Të paktën një foto", "At least one photo"),
  readyDescription: tx("Përshkrimi", "Description"),
  readyBrand: tx("Marka", "Brand"),
  readyStock: tx("Stok në dispozicion", "Stock available"),
  readyColorPhotos: tx("Foto për çdo ngjyrë", "Photos for every colour"),

  // ── Media ────────────────────────────────────────────────
  mdTitle: tx("Imazhet e produktit", "Product images"),
  mdCopy: tx(
    "Ngarko dhe menaxho fotot për secilën ngjyrë. Renditja përcakton rendin në dyqan.",
    "Upload and manage photos for each colour. The order decides the order in the store."
  ),
  mdUpload: tx("Ngarko foto të reja", "Upload new photos"),
  mdUploading: tx("Duke ngarkuar…", "Uploading…"),
  mdUploadTile: tx("Ngarko foto", "Upload photo"),
  mdUploadFormats: tx("JPG, PNG, WEBP · deri 20 MB", "JPG, PNG, WEBP · up to 20 MB"),
  mdLimitLeft: tx("Mund të shtosh edhe {count} foto", "You can add {count} more photos"),
  mdLimitReached: tx(
    "Ke arritur maksimumin prej {max} fotove për produkt. Hiq një foto për të shtuar një tjetër.",
    "You have reached the maximum of {max} photos per product. Remove one to add another."
  ),
  mdLimitExceeded: tx(
    "Zgjodhe {selected} foto, por mund të shtosh vetëm edhe {left}. Asnjë foto nuk u ngarkua — zgjidh më pak.",
    "You selected {selected} photos but can only add {left} more. Nothing was uploaded — choose fewer."
  ),
  mdInvalidType: tx(
    "„{name}” nuk është foto e pranuar. Përdor vetëm JPG, PNG ose WEBP.",
    "“{name}” is not an accepted photo. Use JPG, PNG or WEBP only."
  ),
  mdTooLarge: tx(
    "„{name}” është më e madhe se 20 MB. Zvogëloje dhe provo përsëri.",
    "“{name}” is larger than 20 MB. Make it smaller and try again."
  ),
  mdUploadedPending: tx(
    "{count} foto u ngarkuan. Kliko „Ruaj ndryshimet” që të ruhen te produkti.",
    "{count} photos uploaded. Click “Save changes” to attach them to the product."
  ),
  mdPhotosCount: tx("Fotot: {count}", "Photos: {count}"),
  mdSharedGroup: tx("Për të gjitha ngjyrat", "For all colours"),
  mdSharedGroupHint: tx(
    "Foto që nuk janë lidhur me ndonjë variant shfaqen për çdo ngjyrë.",
    "Photos not linked to a variant show for every colour."
  ),
  mdAllPhotos: tx("Fotot e produktit", "Product photos"),
  mdGroupEmpty: tx(
    "Kjo ngjyrë nuk ka ende foto të veta.",
    "This colour has no photos of its own yet."
  ),
  mdEmptyTitle: tx("Ky produkt nuk ka ende foto", "This product has no photos yet"),
  mdEmptyCopy: tx(
    "Produktet me foto shiten më mirë. Ngarko të paktën një foto kryesore.",
    "Products with photos sell better. Upload at least one main photo."
  ),
  mdProductCover: tx("Kryesore", "Main"),
  mdProductCoverLong: tx("Foto kryesore e produktit", "Main product photo"),
  mdColorCover: tx("Kopertinë e ngjyrës", "Colour cover"),
  mdColorCoverFor: tx("Kopertinë për {color}", "Cover for {color}"),
  mdSetProductCover: tx("Bëje foto kryesore", "Make main photo"),
  mdSetColorCover: tx("Vendos si kopertinë të ngjyrës", "Set as colour cover"),
  mdColorCoverAuto: tx(
    "Pa kopertinë të zgjedhur — dyqani përdor foton e parë të kësaj ngjyre.",
    "No cover chosen — the store uses this colour’s first photo."
  ),
  mdImageActions: tx("Veprimet e fotos", "Photo actions"),
  mdOpenImage: tx("Hap detajet e fotos", "Open photo details"),
  mdImageDetails: tx("Detajet e fotos", "Photo details"),
  mdPositionOf: tx("Pozicioni {n} nga {total} në dyqan", "Position {n} of {total} in the store"),
  mdAltText: tx("Përshkrimi i fotos (alt)", "Photo description (alt)"),
  mdAltHint: tx(
    "Një fjali e shkurtër që përshkruan foton. Ndihmon Google-in dhe personat me shikim të dobët.",
    "A short sentence describing the photo. Helps Google and people with low vision."
  ),
  mdAltPlaceholder: tx("P.sh. Këpucë lëkure ngjyrë taba, pamje anësore", "e.g. Tan leather shoe, side view"),
  mdRole: tx("Lloji i fotos", "Photo type"),
  mdVariantsLink: tx("Për cilat variante vlen kjo foto?", "Which variants is this photo for?"),
  mdVariantsLinkHint: tx(
    "Nëse nuk zgjedh asnjë, fotoja vlen për të gjitha variantet.",
    "If none are selected, the photo is used for every variant."
  ),
  mdVariantsAll: tx("Të gjitha variantet", "All variants"),
  mdVariantsCount: tx("{count} variante", "{count} variants"),
  mdSelectColor: tx("Zgjidh gjithë ngjyrën", "Select whole colour"),
  mdClearColor: tx("Hiq gjithë ngjyrën", "Clear whole colour"),
  mdColorCoverSection: tx("Kopertina e ngjyrës", "Colour cover"),
  mdColorCoverSectionHint: tx(
    "Fotoja që përfaqëson ngjyrën në zgjedhësin e ngjyrave në dyqan.",
    "The photo that represents the colour in the store’s colour picker."
  ),
  mdColorCoverIneligible: tx(
    "Kjo foto nuk mund të vendoset si kopertinë për {color}, sepse nuk i përket asnjë varianti të saj.",
    "This photo can’t be the cover for {color} because it belongs to none of its variants."
  ),
  mdRemovePhoto: tx("Hiq foton", "Remove photo"),
  mdRemoveConfirmTitle: tx("Të hiqet kjo foto?", "Remove this photo?"),
  mdRemoveConfirmCopy: tx(
    "Fotoja hiqet nga produkti kur të ruash ndryshimet. Deri atëherë mund t’i anulosh ndryshimet.",
    "The photo is removed from the product when you save. Until then you can discard the change."
  ),
  mdRemoveConfirmCover: tx(
    "Kjo është foto kryesore. Pas heqjes, foto e parë në renditje bëhet kryesore.",
    "This is the main photo. After removing it, the first photo in the order becomes main."
  ),
  mdOrderTitle: tx("Renditja në dyqan", "Order in the store"),
  mdOrderCopy: tx(
    "Klientët i shohin fotot në këtë rend. Përdor shigjetat për ta ndryshuar.",
    "Customers see the photos in this order. Use the arrows to change it."
  ),
  mdPreview: tx("Pamje paraprake", "Preview"),
  mdStats: tx("Statistikat e imazheve", "Image statistics"),
  mdStatTotal: tx("Totali i fotove", "Total photos"),
  mdStatColors: tx("Ngjyra me foto", "Colours with photos"),
  mdStatCovers: tx("Ngjyra me kopertinë", "Colours with a cover"),
  mdStatAlt: tx("Foto me përshkrim", "Photos with a description"),
  mdStatFormats: tx("Formatet e lejuara", "Allowed formats"),
  mdReadyAll: tx("Gati për publikim", "Ready to publish"),
  mdReadyAllCopy: tx("Produkti ka foto për të gjitha ngjyrat.", "The product has photos for every colour."),
  mdReadyMissing: tx("Mungojnë foto", "Photos missing"),
  mdReadyMissingCopy: tx(
    "Këto ngjyra nuk kanë foto të veta: {colors}. Nuk e bllokon publikimin, por rekomandohet.",
    "These colours have no photos of their own: {colors}. It doesn’t block publishing, but is recommended."
  ),
  mdHintsTitle: tx("Sugjerime", "Suggestions"),
  mdHintAltMany: tx("{count} foto nuk kanë përshkrim (alt).", "{count} photos have no description (alt)."),
  mdPreviewUnavailable: tx("Parapamja nuk është e disponueshme", "Preview unavailable"),
  mdRoleHero: tx("Kryesore (hero)", "Hero"),
  mdRoleGallery: tx("Galeri", "Gallery"),
  mdRoleDetail: tx("Detaj nga afër", "Close-up detail"),
  mdRoleTexture: tx("Tekstura / materiali", "Texture / material"),
  mdRoleModel: tx("Me model", "On model"),
  mdRolePackaging: tx("Paketimi", "Packaging"),
  mdRoleLifestyle: tx("Stil jetese", "Lifestyle"),
  mdRoleOther: tx("Tjetër", "Other"),

  // ── Variants ─────────────────────────────────────────────
  vrTitle: tx("Variantet e produktit", "Product variants"),
  vrCopy: tx(
    "Lista e të gjitha varianteve të gjeneruara nga ngjyrat dhe madhësitë.",
    "Every variant generated from the colours and sizes."
  ),
  vrSearch: tx("Kërko variant, SKU ose barkod…", "Search variant, SKU or barcode…"),
  vrAllValues: tx("Të gjitha: {name}", "All: {name}"),
  vrAllStatuses: tx("Të gjitha statuset", "All statuses"),
  vrColVariant: tx("Varianti", "Variant"),
  vrColPrice: tx("Çmimi", "Price"),
  vrColStock: tx("Stoku", "Stock"),
  vrColStatus: tx("Statusi", "Status"),
  vrColActions: tx("Veprime", "Actions"),
  vrDefault: tx("Kryesor", "Default"),
  vrDefaultHint: tx(
    "Varianti kryesor shfaqet i pari në dyqan.",
    "The default variant is shown first in the store."
  ),
  vrMakeDefault: tx("Bëje variant kryesor", "Make default variant"),
  vrStatusActive: tx("Aktiv", "Active"),
  vrStatusDraft: tx("Draft", "Draft"),
  vrStatusArchived: tx("Arkivuar", "Archived"),
  vrDetails: tx("Detajet", "Details"),
  vrHideDetails: tx("Mbyll detajet", "Hide details"),
  vrSku: tx("SKU", "SKU"),
  vrBarcode: tx("Barkodi", "Barcode"),
  vrBarcodePlaceholder: tx("Gjenerohet automatikisht", "Generated automatically"),
  vrCompareAt: tx("Çmimi krahasues", "Compare-at price"),
  vrCost: tx("Kosto", "Cost"),
  vrPrintLabel: tx("Printo etiketën", "Print label"),
  vrNoBarcode: tx("Pa barkod — nuk mund të printohet", "No barcode — cannot be printed"),
  vrViewStock: tx("Shiko stokun", "View stock"),
  vrSelected: tx("{count} të zgjedhura", "{count} selected"),
  vrPrintSelected: tx("Printo etiketat ({count})", "Print labels ({count})"),
  vrClearSelection: tx("Pastro zgjedhjen", "Clear selection"),
  vrSetStatusSelected: tx("Vendos statusin", "Set status"),
  vrSelectAll: tx("Zgjidh të gjitha variantet me barkod", "Select all variants with a barcode"),
  vrTotal: tx("{count} variante gjithsej", "{count} variants in total"),
  vrShown: tx("{shown} nga {total} variante", "{shown} of {total} variants"),
  vrNoMatch: tx("Asnjë variant nuk përputhet me filtrat.", "No variant matches the filters."),
  vrResetFilters: tx("Pastro filtrat", "Reset filters"),
  vrEmptyTitle: tx("Ky produkt nuk ka variante", "This product has no variants"),
  vrEmptyCopy: tx(
    "Shto ngjyrat dhe madhësitë te „Struktura e varianteve” për t’i krijuar.",
    "Add colours and sizes under “Variant structure” to create them."
  ),
  vrArchivedTitle: tx("Variantet e arkivuara ({count})", "Archived variants ({count})"),
  vrArchivedCopy: tx(
    "Nuk shiten dhe nuk shfaqen në dyqan. Ruhen për historikun e shitjeve.",
    "Not sold and not shown in the store. Kept for sales history."
  ),
  vrStructure: tx("Struktura e varianteve", "Variant structure"),
  vrStructureSimple: tx(
    "Ky produkt nuk ka variante — shitet si një artikull i vetëm.",
    "This product has no variants — it is sold as a single item."
  ),
  vrStructureFormula: tx("{parts} = {count} variante", "{parts} = {count} variants"),
  vrStructureManual: tx(
    "Kombinime të zgjedhura me dorë: {count} variante",
    "Hand-picked combinations: {count} variants"
  ),
  vrChangeStructure: tx("Ndrysho strukturën", "Change structure"),
  vrPricing: tx("Çmimet e varianteve", "Variant prices"),
  vrPricingSame: tx("I njëjtë për të gjitha", "Same for all"),
  vrPricingMixed: tx("Të ndryshme", "Different"),
  vrPricingEdit: tx("Ndrysho çmimin për të gjitha", "Change price for all"),
  vrQuickStats: tx("Statistika të shpejta", "Quick stats"),
  vrStatVariants: tx("Variante", "Variants"),
  vrStatStock: tx("Në dispozicion", "Available"),
  vrStatSkus: tx("SKU unike", "Unique SKUs"),
  vrStatBarcodes: tx("Me barkod", "With barcode"),
  vrNotSaved: tx("I paruajtur", "Unsaved"),

  // Structure editor
  stTitle: tx("Ndrysho strukturën e varianteve", "Change variant structure"),
  stCopy: tx(
    "Shto ose hiq ngjyra, madhësi ose opsione të tjera. Variantet ekzistuese ruajnë SKU-në, barkodin, çmimin dhe stokun.",
    "Add or remove colours, sizes or other options. Existing variants keep their SKU, barcode, price and stock."
  ),
  stHasVariants: tx("A ka variante ky produkt?", "Does this product have variants?"),
  stYes: tx("Po, ka variante", "Yes, it has variants"),
  stNo: tx("Jo, është një artikull i vetëm", "No, it is a single item"),
  stOptions: tx("Opsionet", "Options"),
  stOptionName: tx("Emri i opsionit", "Option name"),
  stOptionNamePlaceholder: tx("P.sh. Ngjyra ose Madhësia", "e.g. Colour or Size"),
  stValues: tx("Vlerat", "Values"),
  stValuesPlaceholder: tx("P.sh. Taba, Zi, Bezhë", "e.g. Tan, Black, Beige"),
  stValuesHint: tx("Ndaji me presje.", "Separate with commas."),
  stAddOption: tx("Shto opsion", "Add option"),
  stAddOtherOption: tx("Opsion tjetër", "Other option"),
  stColorOption: tx("Ngjyra", "Colour"),
  stSizeOption: tx("Madhësia", "Size"),
  stPickValues: tx("Zgjidh vlerat", "Pick values"),
  stRemoveOption: tx("Hiq opsionin", "Remove option"),
  stCombinations: tx("Kombinimet", "Combinations"),
  stAddCombination: tx("Shto kombinim", "Add combination"),
  stCombinationsEmpty: tx(
    "Nuk ka kombinime. Shto të paktën një.",
    "No combinations yet. Add at least one."
  ),
  stSelect: tx("Zgjidh", "Choose"),
  stAdvanced: tx("Cilësime të avancuara", "Advanced settings"),
  stGeneration: tx("Si krijohen variantet", "How variants are created"),
  stGenCartesian: tx("Të gjitha kombinimet automatikisht", "Every combination automatically"),
  stGenManual: tx("Vetëm kombinimet që zgjedh unë", "Only the combinations I choose"),
  stInventory: tx("Ndjekja e stokut", "Stock tracking"),
  stInventoryWarn: tx(
    "Mos e ndrysho mënyrën e ndjekjes së stokut nëse produkti ka tashmë stok — pyet administratorin.",
    "Don’t change stock tracking if the product already has stock — ask an administrator."
  ),
  stPreview: tx("Çfarë do të ndodhë", "What will happen"),
  stPreviewNew: tx("{count} variante të reja do të krijohen", "{count} new variants will be created"),
  stPreviewArchived: tx(
    "{count} variante do të arkivohen (nuk shiten më)",
    "{count} variants will be archived (no longer sold)"
  ),
  stPreviewKept: tx("{count} variante mbeten siç janë", "{count} variants stay as they are"),
  stPreviewEstimate: tx(
    "Parashikim sipas vlerave të shkruara. Serveri e konfirmon pas ruajtjes.",
    "Estimate based on the values entered. The server confirms it after saving."
  ),
  stSave: tx("Ruaj strukturën", "Save structure"),
  stConfirmTitle: tx("Të ruhet struktura e re?", "Save the new structure?"),
  stConfirmArchive: tx(
    "Kujdes: {count} variante do të arkivohen. Stoku i tyre mbetet i regjistruar, por ato nuk do të shiten më.",
    "Careful: {count} variants will be archived. Their stock stays recorded, but they will no longer be sold."
  ),
  stConfirmCopy: tx(
    "Struktura ruhet menjëherë. Çmimet dhe ndryshimet e paruajtura të varianteve ruhen bashkë me të.",
    "The structure is saved right away. Unsaved variant and price changes are saved with it."
  ),
  stConfirmAction: tx("Po, ruaj strukturën", "Yes, save structure"),
  stSaved: tx("Struktura u ruajt.", "Structure saved."),
  stSavedCreated: tx("{count} variante të reja", "{count} new variants"),
  stSavedRestored: tx("{count} variante të rikthyera", "{count} restored variants"),
  stSavedArchived: tx("{count} variante të arkivuara", "{count} archived variants"),

  // ── Stock ────────────────────────────────────────────────
  skTitle: tx("Menaxhimi i stokut", "Stock management"),
  skCopy: tx(
    "Shiko dhe rregullo stokun për të gjitha variantet dhe lokacionet.",
    "View and manage stock for every variant and location."
  ),
  skAddStock: tx("Shto stok", "Add stock"),
  skAdjust: tx("Rregullo stokun", "Adjust stock"),
  skAdjustSerializedOff: tx(
    "Rregullimi manual nuk mbështetet për produktet me njësi të serializuara. Përdor „Shto stok”.",
    "Manual adjustment isn’t supported for serialized products. Use “Add stock”."
  ),
  skOnHand: tx("Në dorë", "On hand"),
  skOnHandHint: tx("Copat fizikisht në lokacion", "Items physically at the location"),
  skReserved: tx("I rezervuar", "Reserved"),
  skReservedHint: tx("Të mbajtura për porosi që ende s’janë dërguar", "Held for orders not yet shipped"),
  skAvailable: tx("Në dispozicion", "Available"),
  skAvailableHint: tx("Mund të shiten tani (në dorë − të rezervuara)", "Can be sold now (on hand − reserved)"),
  skLocations: tx("Lokacionet", "Locations"),
  skHealth: tx("Gjendja", "Status"),
  skHealthOk: tx("Normal", "Normal"),
  skHealthLow: tx("Stok i ulët", "Low stock"),
  skHealthOut: tx("Pa stok", "Out of stock"),
  skHealthNeedsAttention: tx("Kërkojnë vëmendje", "Need attention"),
  skHealthNeedsAttentionCopy: tx(
    "{out} pa stok · {low} me stok të ulët",
    "{out} out of stock · {low} low"
  ),
  skVariantsAndStock: tx("Variantet dhe stoku", "Variants and stock"),
  skSearch: tx("Kërko ngjyrë, madhësi, SKU…", "Search colour, size, SKU…"),
  skAllLocations: tx("Të gjitha lokacionet", "All locations"),
  skAllHealth: tx("Çdo gjendje", "Any status"),
  skTotal: tx("Totali", "Total"),
  skShort: tx("Disp.", "Avail."),
  skShortReserved: tx("Rez.", "Res."),
  skSerializedTitle: tx("Njësi të serializuara", "Serialized units"),
  skSerializedCopy: tx(
    "Çdo copë ka barkodin e vet. Numrat tregojnë njësitë sipas gjendjes.",
    "Each item has its own barcode. The numbers show units by state."
  ),
  skSold: tx("Shitur", "Sold"),
  skReturned: tx("Kthyer", "Returned"),
  skDamaged: tx("Dëmtuar", "Damaged"),
  skAllUnits: tx("Gjithsej njësi", "Total units"),
  skVariantDetails: tx("Detajet e variantit", "Variant details"),
  skVariantDetailsEmpty: tx(
    "Zgjidh një variant në tabelë për të parë stokun sipas lokacionit.",
    "Pick a variant in the table to see its stock by location."
  ),
  skByLocation: tx("Stoku sipas lokacionit", "Stock by location"),
  skNoLocationStock: tx("Ky variant nuk ka ende stok në asnjë lokacion.", "This variant has no stock at any location yet."),
  skRecentMoves: tx("Lëvizjet e fundit", "Recent movements"),
  skSeeAll: tx("Shiko të gjitha", "See all"),
  skNoMoves: tx("Ende nuk ka lëvizje stoku.", "No stock movements yet."),
  skEmptyTitle: tx("Nuk ka variante për stok", "No variants to stock"),
  skEmptyCopy: tx(
    "Krijo variantet te skeda Variantet para se të shtosh stok.",
    "Create the variants in the Variants tab before adding stock."
  ),
  skNoStockYet: tx(
    "Ky produkt nuk ka ende stok. Kliko „Shto stok” kur të mbërrijë malli.",
    "This product has no stock yet. Click “Add stock” when goods arrive."
  ),

  // Restock drawer
  rsTitle: tx("Shto stok", "Add stock"),
  rsCopy: tx(
    "Shto njësi të reja te variantet ekzistuese pa ndryshuar strukturën e produktit. Ky veprim rrit stokun „Në dorë” vetëm për lokacionin e zgjedhur.",
    "Add new units to existing variants without changing the product structure. This only increases “On hand” stock at the chosen location."
  ),
  rsSelectedVariants: tx("Variantet e zgjedhura", "Variants selected"),
  rsOfTotal: tx("nga {count} gjithsej", "of {count} in total"),
  rsUnitsToAdd: tx("Njësi për t’u shtuar", "Units to add"),
  rsUnitsTotal: tx("njësi gjithsej", "units in total"),
  rsLocation: tx("Lokacioni", "Location"),
  rsChooseLocation: tx("Zgjidh lokacionin", "Choose location"),
  rsSearch: tx("Kërko variant", "Find variant"),
  rsSearchPlaceholder: tx("Kërko sipas variantit, SKU ose barkodit…", "Search by variant, SKU or barcode…"),
  rsSelectLow: tx("Zgjidh të gjitha me stok të ulët ({count})", "Select all low-stock variants ({count})"),
  rsSelectLowHint: tx(
    "Stok i ulët = 2 ose më pak copë në dispozicion në këtë lokacion.",
    "Low stock = 2 or fewer items available at this location."
  ),
  rsClear: tx("Pastro sasitë", "Clear quantities"),
  rsColVariant: tx("Varianti", "Variant"),
  rsColCurrent: tx("Në dorë", "On hand"),
  rsColCurrentSerialized: tx("Disp. gjithsej", "Avail. total"),
  rsColAdd: tx("Shto njësi", "Add units"),
  rsColResult: tx("Stoku i ri", "New stock"),
  rsDecrease: tx("Zvogëlo", "Decrease"),
  rsIncrease: tx("Rrit", "Increase"),
  rsQuantityFor: tx("Sasia për {variant}", "Quantity for {variant}"),
  rsLowBadge: tx("Stok i ulët", "Low stock"),
  rsOutBadge: tx("Pa stok", "Out of stock"),
  rsNoMatch: tx("Asnjë variant nuk përputhet me kërkimin.", "No variant matches your search."),
  rsFooterNote: tx(
    "Ky veprim rrit vetëm stokun „Në dorë” për variantet e zgjedhura në lokacionin {location}. Nuk ndikon te rezervimet, porositë ekzistuese apo lokacionet e tjera.",
    "This only increases “On hand” stock for the selected variants at {location}. It does not affect reservations, existing orders or other locations."
  ),
  rsFooterNoteSerialized: tx(
    "Për çdo copë krijohet një njësi e re me barkod të vetin në lokacionin {location}. Rezervimet dhe porositë ekzistuese nuk ndikohen.",
    "Each item becomes a new unit with its own barcode at {location}. Reservations and existing orders are not affected."
  ),
  rsSerializedCurrentHint: tx(
    "Për produktet e serializuara tregohet gjendja e të gjitha lokacioneve bashkë.",
    "For serialized products the count covers all locations together."
  ),
  rsSave: tx("Ruaj rimbushjen", "Save restock"),
  rsSaveSummary: tx("{variants} variante · {units} njësi", "{variants} variants · {units} units"),
  rsSaveSummaryOne: tx("{variants} variant · {units} njësi", "{variants} variant · {units} units"),
  rsSaving: tx("Duke ruajtur…", "Saving…"),
  rsSuccessTitle: tx("Stoku u shtua", "Stock added"),
  rsSuccessCopy: tx(
    "Stoku i ri u regjistrua. Mund të printosh etiketat për copat e reja tani.",
    "The new stock was recorded. You can print labels for the new items now."
  ),
  rsSuccessCopyLabelled: tx("Stoku i ri u regjistrua.", "The new stock was recorded."),
  rsSuccessVariants: tx("Variante të rimbushura", "Variants restocked"),
  rsSuccessUnits: tx("Njësi të shtuara", "Units added"),
  rsPrintNow: tx("Printo etiketat tani", "Print labels now"),
  rsNeedsLabels: tx("Kanë nevojë për etiketa Black & White", "Needs Black & White labels"),
  rsNeedsLabelsOn: tx(
    "Copat e reja do të shfaqen te Qendra e printimit, te „Kanë nevojë për etiketa”. Çaktivizoje nëse e kanë tashmë etiketën tonë.",
    "The new items will appear in the Print Center under “Needs labels”. Turn this off if they already carry our label."
  ),
  rsNeedsLabelsOff: tx(
    "Copat konsiderohen të etiketuara. Mund t’i printosh përsëri kur të duash.",
    "The items are treated as already labelled. You can still print labels any time."
  ),
  rsNeedsLabelsSerialized: tx(
    "Gjithmonë: çdo copë merr barkodin e vet të ri, prandaj ka nevojë për etiketë.",
    "Always: each item gets its own new barcode, so it needs its own label."
  ),
  rsSaveNoLabels: tx("pa etiketa", "no labels"),
  rsMoreUnits: tx("+{count} të tjera", "+{count} more"),
  rsUnitBarcodesPending: tx("Barkodet e copave te Qendra e printimit", "Unit barcodes in the Print Center"),
  rsPrintLabels: tx("Printo {count} etiketa", "Print {count} labels"),
  rsPrintLabelsOne: tx("Printo 1 etiketë", "Print 1 label"),
  rsLabelsNeeded: tx(
    "{count} copa të reja kanë nevojë për etiketa. Qendra e printimit hapet me to të zgjedhura.",
    "{count} new items need labels. The Print Center opens with them selected."
  ),
  rsLabelsNeededOne: tx(
    "1 copë e re ka nevojë për etiketë. Qendra e printimit hapet me të të zgjedhur.",
    "1 new item needs a label. The Print Center opens with it selected."
  ),
  rsLabelsNotNeeded: tx(
    "Shënuar si të etiketuara: nuk u shtua asgjë te „Kanë nevojë për etiketa”.",
    "Marked as already labelled: nothing was added to “Needs labels”."
  ),
  createdLabelsTitle: tx("Etiketat për stokun fillestar", "Labels for the opening stock"),
  createdLabelsCopy: tx(
    "{count} copa të reja kanë nevojë për etiketa Black & White.",
    "{count} new items need Black & White labels."
  ),
  createdLabelsCopyOne: tx(
    "1 copë e re ka nevojë për etiketë Black & White.",
    "1 new item needs a Black & White label."
  ),
  createdLabelsLater: tx("Më vonë", "Later"),
  rsNoPrintable: tx(
    "Variantet e rimbushura nuk kanë ende barkod për printim.",
    "The restocked variants don’t have a printable barcode yet."
  ),
  rsError: tx("Stoku nuk u shtua. Provo përsëri.", "Stock was not added. Try again."),

  // Adjust drawer
  adTitle: tx("Rregullo stokun", "Adjust stock"),
  adCopy: tx(
    "Për korrigjime pas numërimit, dëmtimeve ose gabimeve. Për mall të ri përdor „Shto stok”.",
    "For corrections after a count, damage or mistakes. For new goods use “Add stock”."
  ),
  adVariant: tx("Varianti", "Variant"),
  adChooseVariant: tx("Zgjidh variantin", "Choose variant"),
  adLocation: tx("Lokacioni", "Location"),
  adWhat: tx("Çfarë do të bësh?", "What do you want to do?"),
  adModeAdd: tx("Shto njësi", "Add units"),
  adModeAddHint: tx("P.sh. gjete copa që mungonin", "e.g. you found missing items"),
  adModeRemove: tx("Hiq njësi", "Remove units"),
  adModeRemoveHint: tx("P.sh. copë e dëmtuar ose e humbur", "e.g. a damaged or lost item"),
  adModeSet: tx("Vendos sasinë e saktë", "Set exact quantity"),
  adModeSetHint: tx("P.sh. pas numërimit të raftit", "e.g. after counting the shelf"),
  adQtyAdd: tx("Sa njësi do të shtosh?", "How many units to add?"),
  adQtyRemove: tx("Sa njësi do të heqësh?", "How many units to remove?"),
  adQtySet: tx("Sa copë ka saktësisht tani?", "How many items are there exactly now?"),
  adReason: tx("Arsyeja", "Reason"),
  adReasonCorrection: tx("Korrigjim pas numërimit", "Correction after a count"),
  adReasonManual: tx("Rregullim manual", "Manual adjustment"),
  adNote: tx("Shënim", "Note"),
  adNotePlaceholder: tx("P.sh. 1 copë e dëmtuar gjatë transportit", "e.g. 1 item damaged in transport"),
  adCurrent: tx("Në dorë tani", "On hand now"),
  adReservedNow: tx("Të rezervuara", "Reserved"),
  adResult: tx("Pas ndryshimit", "After the change"),
  adResultNote: tx(
    "Ndryshon vetëm „Në dorë” në këtë lokacion. Rezervimet mbeten {reserved}.",
    "Only “On hand” at this location changes. Reservations stay at {reserved}."
  ),
  adErrNoChange: tx("Ky ndryshim nuk e ndryshon stokun.", "This change doesn’t alter stock."),
  adErrNegative: tx("Stoku nuk mund të bëhet negativ.", "Stock cannot go below zero."),
  adErrReserved: tx(
    "Nuk mund të zbresësh nën {reserved} copë, sepse janë të rezervuara për porosi.",
    "You can’t go below {reserved} items because they are reserved for orders."
  ),
  adErrWhole: tx("Shkruaj një numër të plotë pozitiv.", "Enter a whole positive number."),
  adSave: tx("Ruaj rregullimin", "Save adjustment"),
  adSaved: tx("Stoku u rregullua.", "Stock adjusted."),
  adError: tx("Stoku nuk u rregullua. Provo përsëri.", "Stock was not adjusted. Try again."),

  // ── Details ──────────────────────────────────────────────
  dtStory: tx("Historia e produktit", "Product story"),
  dtStoryCopy: tx(
    "Teksti i gjatë që tregon produktin në faqen e dyqanit.",
    "The longer text that presents the product on the store page."
  ),
  dtStoryPlaceholder: tx(
    "P.sh. Dizajn klasik i frymëzuar nga koleksionet tradicionale, i punuar me kujdes për përdorim të përditshëm.",
    "e.g. A classic design inspired by traditional collections, carefully made for everyday wear."
  ),
  dtHighlights: tx("Pikat kryesore", "Key highlights"),
  dtHighlightsCopy: tx("Shfaqen si listë me ikona në webshop.", "Shown as an icon list in the webshop."),
  dtHighlightPlaceholder: tx("P.sh. Lëkurë natyrale", "e.g. Genuine leather"),
  dtAddHighlight: tx("Shto pikë kryesore", "Add highlight"),
  dtInfo: tx("Informacione të detajuara", "Detailed information"),
  dtInfoCopy: tx(
    "Detaje që ndihmojnë klientët të kuptojnë produktin.",
    "Details that help customers understand the product."
  ),
  dtMaterial: tx("Materiali", "Material"),
  dtMaterialPlaceholder: tx("P.sh. Lëkurë natyrale", "e.g. Genuine leather"),
  dtComposition: tx("Përbërja", "Composition"),
  dtCompositionPlaceholder: tx("P.sh. 100% lëkurë", "e.g. 100% leather"),
  dtCare: tx("Kujdesi", "Care"),
  dtCarePlaceholder: tx("P.sh. Pastrohen me leckë të lagur.", "e.g. Wipe with a damp cloth."),
  dtFit: tx("Përshtatja (Fit)", "Fit"),
  dtFitPlaceholder: tx("P.sh. Përshtatje normale", "e.g. True to size"),
  dtSizeGuide: tx("Udhëzuesi i madhësive", "Size guide"),
  dtSizeGuidePlaceholder: tx("P.sh. Përputhet me madhësitë standarde.", "e.g. Matches standard sizes."),
  dtBadges: tx("Badge dhe etiketa", "Badges and labels"),
  dtBadgesCopy: tx(
    "Etiketa të shkurtra që shfaqen në faqe dhe në listën e produkteve.",
    "Short labels shown on the page and in product lists."
  ),
  dtBadgePlaceholder: tx("P.sh. Bestseller", "e.g. Bestseller"),
  dtAddBadge: tx("Shto badge", "Add badge"),
  dtBadgesEmpty: tx("Nuk ka badge.", "No badges."),
  dtStyling: tx("Stilimi & kombinimi", "Styling & pairing"),
  dtStylingCopy: tx("Sugjerime për veshje dhe raste përdorimi.", "Outfit and occasion suggestions."),
  dtStylingPlaceholder: tx(
    "P.sh. Përshtaten perfekt me veshje të përditshme, pantallona dhe fustane.",
    "e.g. Pair perfectly with everyday outfits, trousers and dresses."
  ),
  dtSections: tx("Seksione shtesë", "Extra sections"),
  dtSectionsCopy: tx(
    "Blloqe me titull dhe tekst, p.sh. „Specifikime” ose „Dërgesa”. Ruhen vetëm ato me titull dhe tekst.",
    "Blocks with a title and text, e.g. “Specifications” or “Delivery”. Only blocks with both are saved."
  ),
  dtSectionTitle: tx("Titulli", "Title"),
  dtSectionTitlePlaceholder: tx("P.sh. Specifikime", "e.g. Specifications"),
  dtSectionBody: tx("Teksti", "Text"),
  dtSectionBodyPlaceholder: tx("P.sh. Takë 6 cm, shollë gome.", "e.g. 6 cm heel, rubber sole."),
  dtAddSection: tx("Shto seksion", "Add section"),
  dtSectionsEmpty: tx("Nuk ka seksione shtesë.", "No extra sections."),
  dtSectionIncomplete: tx(
    "Ky seksion nuk do të ruhet pa titull dhe tekst.",
    "This section won’t be saved without a title and text."
  ),
  dtPreview: tx("Parapamje në webshop", "Webshop preview"),
  dtPreviewNote: tx(
    "Parapamje e thjeshtuar me të dhënat aktuale (përfshirë ato të paruajtura).",
    "A simplified preview using the current data (including unsaved edits)."
  ),
  dtPreviewEmpty: tx("Shto detaje që të shfaqen këtu.", "Add details to see them here."),
  dtClassification: tx("Klasifikimi", "Classification"),
  dtClassificationCopy: tx(
    "Marka, kategoria dhe lloji përdoren për filtrat në webshop dhe për Meta Catalog.",
    "Brand, category and type power webshop filters and the Meta Catalog."
  ),
  dtEditInOverview: tx("Ndrysho te Përmbledhje", "Edit in Overview"),

  // ── Publishing ───────────────────────────────────────────
  pbStatusTitle: tx("Statusi dhe publikimi", "Status and publishing"),
  pbStatusCopy: tx(
    "Menaxho ku dhe si do të shfaqet ky produkt. Ndryshimi i statusit ruhet menjëherë.",
    "Manage where and how this product appears. Status changes are saved immediately."
  ),
  pbPublishedTitle: tx("Aktiv në dyqan", "Live in store"),
  pbPublishedCopy: tx(
    "Klientët e shohin dhe e blejnë online. Shitet edhe në shitore.",
    "Customers can see and buy it online. Also sold in the shop."
  ),
  pbPosOnlyTitle: tx("Vetëm në shitore", "Shop only"),
  pbPosOnlyCopy: tx(
    "Shitet në arkë, por nuk shfaqet në dyqanin online.",
    "Sold at the till but hidden from the online store."
  ),
  pbDraftTitle: tx("Draft", "Draft"),
  pbDraftCopy: tx(
    "Nuk shitet askund. E ruajtur, por e fshehur.",
    "Not sold anywhere. Saved but hidden."
  ),
  pbArchivedTitle: tx("Arkivuar", "Archived"),
  pbArchivedCopy: tx(
    "Hequr nga dyqani dhe nga shitja. Ruhet vetëm për historik.",
    "Removed from the store and from sale. Kept for history only."
  ),
  pbChoose: tx("Zgjidh", "Choose"),
  pbIsCurrent: tx("Statusi aktual", "Current"),
  pbBlockedBy: tx("Nuk mund të aktivizohet ende", "Can’t be activated yet"),
  pbConfirmPublishTitle: tx("Të publikohet në dyqan?", "Publish to the store?"),
  pbConfirmPublishCopy: tx(
    "Produkti do të shfaqet menjëherë në dyqanin online. Të gjitha variantet jo të arkivuara bëhen aktive.",
    "The product appears in the online store right away. All non-archived variants become active."
  ),
  pbConfirmPosTitle: tx("Të shitet vetëm në shitore?", "Sell in the shop only?"),
  pbConfirmPosCopyFromLive: tx(
    "Produkti hiqet nga dyqani online, por mbetet në shitje në shitore. Të gjitha variantet jo të arkivuara bëhen aktive. Porositë ekzistuese nuk ndikohen.",
    "The product leaves the online store but stays on sale in the shop. All non-archived variants become active. Existing orders are not affected."
  ),
  pbConfirmPosCopy: tx(
    "Produkti bëhet aktiv për shitje në shitore, por nuk shfaqet online. Të gjitha variantet jo të arkivuara bëhen aktive.",
    "The product becomes active for in-shop sale but stays hidden online. All non-archived variants become active."
  ),
  pbConfirmDraftTitle: tx("Të kthehet në draft?", "Move back to draft?"),
  pbConfirmDraftCopy: tx(
    "Produkti hiqet nga dyqani dhe nga shitja në shitore. Të gjitha variantet jo të arkivuara bëhen draft.",
    "The product leaves the store and in-shop sale. All non-archived variants become drafts."
  ),
  pbConfirmArchiveTitle: tx("Të arkivohet produkti?", "Archive this product?"),
  pbConfirmArchiveCopy: tx(
    "Produkti hiqet nga dyqani dhe nga shitja. KUJDES: të gjitha variantet arkivohen gjithashtu dhe asnjë variant nuk mbetet kryesor. Kjo nuk kthehet me një klik: variantet mbeten të arkivuara edhe nëse produkti kthehet më vonë në draft.",
    "The product is removed from the store and from sale. CAREFUL: every variant is archived too and no variant stays the default. This can’t be undone with one click: the variants stay archived even if the product is later moved back to draft."
  ),
  pbConfirmArchiveAction: tx("Po, arkivoje", "Yes, archive"),
  pbConfirmAction: tx("Po, vazhdo", "Yes, continue"),
  pbUnsavedWarning: tx(
    "Ke ndryshime të paruajtura. Ndryshimi i statusit nuk i ruan ato — ruaji më parë nëse duhet të përfshihen.",
    "You have unsaved changes. Changing the status doesn’t save them — save first if they should be included."
  ),
  pbSavedPublished: tx("Produkti u publikua në dyqan.", "The product is now live in the store."),
  pbSavedPosOnly: tx("Produkti tani shitet vetëm në shitore.", "The product is now sold in the shop only."),
  pbSavedDraft: tx("Produkti u kthye në draft.", "The product is back in draft."),
  pbSavedArchived: tx("Produkti u arkivua.", "The product was archived."),
  pbError: tx("Statusi nuk u ndryshua. Provo përsëri.", "The status was not changed. Try again."),
  pbMetaTitle: tx("Përfshi në Meta Catalog", "Include in the Meta Catalog"),
  pbMetaCopy: tx(
    "Produkti dërgohet te katalogu i Facebook/Instagram. Nuk ndikon te dyqani online.",
    "Sends the product to the Facebook/Instagram catalog. Doesn’t affect the online store."
  ),
  pbMetaSaveHint: tx("Ruhet me „Ruaj ndryshimet”.", "Saved with “Save changes”."),
  pbSeoTitle: tx("Adresa në internet (URL)", "Web address (URL)"),
  pbSeoCopy: tx(
    "Pjesa e fundit e adresës së produktit në dyqan. Lëre bosh që të krijohet nga emri.",
    "The last part of the product’s store address. Leave empty to create it from the name."
  ),
  pbSlug: tx("URL (slug)", "URL (slug)"),
  pbSlugPlaceholder: tx("p.sh. classic-runner", "e.g. classic-runner"),
  pbSlugWarning: tx(
    "Ndryshimi i URL-së prish lidhjet e vjetra që klientët mund të kenë ruajtur ose ndarë.",
    "Changing the URL breaks old links customers may have saved or shared."
  ),
  pbSlugNormalized: tx(
    "Serveri mund ta përshtatë URL-në (p.sh. shton një numër) nëse është e zënë.",
    "The server may adjust the URL (e.g. add a number) if it is taken."
  ),
  pbGoogleTitle: tx("Pamje në Google", "Google preview"),
  pbGoogleCopy: tx(
    "Përafrim i krijuar nga emri dhe përshkrimi i produktit. Titulli dhe përshkrimi SEO i veçantë nuk mbështeten ende.",
    "An approximation built from the product name and description. A separate SEO title and description aren’t supported yet."
  ),
  pbGoogleNoDescription: tx(
    "Shto një përshkrim te Përmbledhje që Google të ketë çfarë të shfaqë.",
    "Add a description in Overview so Google has something to show."
  ),
  pbChecklist: tx("Kontrollo para publikimit", "Pre-publish check"),
  pbChecklistCopy: tx(
    "Rregullat e serverit, sipas të dhënave të ruajtura.",
    "The server’s rules, based on the saved data."
  ),
  pbBlockersTitle: tx("Duhet rregulluar para publikimit", "Must be fixed before publishing"),
  pbBlockersNone: tx("Asgjë nuk e bllokon publikimin.", "Nothing blocks publishing."),
  pbRecommendations: tx("Rekomandime (nuk bllokojnë)", "Recommendations (not blocking)"),
  pbRecNoPhotos: tx("Shto të paktën një foto", "Add at least one photo"),
  pbRecNoDescription: tx("Shto përshkrimin e shkurtër", "Add a short description"),
  pbRecNoStock: tx("Asnjë variant nuk ka stok në dispozicion", "No variant has stock available"),
  pbRecNoBrand: tx("Zgjidh markën", "Choose the brand"),
  pbRecMissingAlt: tx("{count} foto pa përshkrim (alt)", "{count} photos without a description (alt)"),
  pbRecColorPhotos: tx("Ngjyra pa foto: {colors}", "Colours without photos: {colors}"),
  pbDanger: tx("Veprime të rrezikshme", "Danger zone"),
  pbDangerCopy: tx(
    "Këto veprime ndikojnë menjëherë te dyqani dhe shitja.",
    "These actions immediately affect the store and sales."
  ),
  pbArchive: tx("Arkivo produktin", "Archive product"),

  // Blocking issues (server rules → Albanian)
  biTitle: tx("Emri i produktit mungon.", "The product name is missing."),
  biFamily: tx("Kategoria mungon.", "The category is missing."),
  biNoVariant: tx(
    "Duhet të paktën një variant që nuk është i arkivuar.",
    "At least one non-archived variant is required."
  ),
  biSimple: tx(
    "Produkti pa variante duhet të ketë saktësisht një variant.",
    "A product without variants must have exactly one variant."
  ),
  biDefault: tx(
    "Duhet të zgjidhet saktësisht një variant kryesor.",
    "Exactly one default variant must be chosen."
  ),
  biSku: tx("Çdo variant duhet të ketë SKU.", "Every variant needs a SKU."),
  biPrice: tx("Çdo variant duhet të ketë çmim.", "Every variant needs a price."),

  // ── History ──────────────────────────────────────────────
  hsTitle: tx("Historiku i stokut", "Stock history"),
  hsCopy: tx(
    "Çdo hyrje, dalje dhe korrigjim i stokut për këtë produkt, i renditur sipas datës.",
    "Every stock entry, exit and correction for this product, newest first."
  ),
  hsScopeNote: tx(
    "Sistemi regjistron historikun vetëm për stokun. Ndryshimet e çmimit, fotove, tekstit ose statusit nuk regjistrohen ende.",
    "The system records history for stock only. Price, photo, text or status changes aren’t recorded yet."
  ),
  hsAllTypes: tx("Të gjitha", "All"),
  hsVariant: tx("Varianti", "Variant"),
  hsAllVariants: tx("Të gjitha variantet", "All variants"),
  hsLocation: tx("Lokacioni", "Location"),
  hsToday: tx("Sot", "Today"),
  hsYesterday: tx("Dje", "Yesterday"),
  hsEmpty: tx("Ende nuk ka lëvizje stoku për këtë produkt.", "No stock movements for this product yet."),
  hsEmptyFiltered: tx("Asnjë lëvizje nuk përputhet me filtrat.", "No movement matches the filters."),
  hsLoadMore: tx("Ngarko më shumë", "Load more"),
  hsShowing: tx("Po shfaqen {shown} nga {total} lëvizje", "Showing {shown} of {total} movements"),
  hsMaxReached: tx(
    "Shfaqen 100 lëvizjet më të fundit. Përdor filtrat për të parë më të vjetrat.",
    "The 100 most recent movements are shown. Use the filters to see older ones."
  ),
  hsSummary: tx("Përmbledhje", "Summary"),
  hsSummaryCopy: tx("Nga lëvizjet e shfaqura në listë.", "From the movements shown in the list."),
  hsUnitsIn: tx("Njësi të hyra", "Units in"),
  hsUnitsOut: tx("Njësi të dala", "Units out"),
  hsMoves: tx("Lëvizje", "Movements"),
  hsFilters: tx("Filtrat", "Filters"),
  hsFrom: tx("{before} → {after}", "{before} → {after}"),
  hsReference: tx("Referenca: {ref}", "Reference: {ref}"),
  hsError: tx("Historiku nuk u ngarkua. Provo përsëri.", "History could not be loaded. Try again."),
  mvRestock: tx("Rimbushje stoku", "Restock"),
  mvUndoReceive: tx("Anulim i pranimit", "Receiving undone"),
  mvManualAdjustment: tx("Rregullim manual", "Manual adjustment"),
  mvCorrection: tx("Korrigjim", "Correction"),
  mvImport: tx("Import", "Import"),
  mvSale: tx("Shitje", "Sale"),
  mvReturn: tx("Kthim", "Return"),
  mvTransfer: tx("Transferim", "Transfer"),
  mvSerializedUnitCreate: tx("Krijim njësish", "Units created"),
  mvOther: tx("Lëvizje stoku", "Stock movement"),
  mvSentenceIn: tx("{actor} shtoi {count} copë", "{actor} added {count} items"),
  mvSentenceOut: tx("{actor} hoqi {count} copë", "{actor} removed {count} items"),
  mvSentenceSale: tx("{actor} shiti {count} copë", "{actor} sold {count} items"),
  mvSentenceSaleCancel: tx("{actor} riktheu {count} copë nga një shitje", "{actor} put back {count} items from a sale"),
  mvSentenceReturn: tx("{actor} ktheu {count} copë në stok", "{actor} returned {count} items to stock"),
  refSale: tx("Shitja #{id}", "Sale #{id}"),
  refOrder: tx("Porosia #{id}", "Order #{id}"),
  refOrderEdit: tx("Ndryshim i porosisë #{id}", "Order change #{id}"),
  refReturn: tx("Kthimi #{id}", "Return #{id}"),
  refExchange: tx("Këmbimi #{id}", "Exchange #{id}"),
  refUndo: tx("Anulon lëvizjen #{id}", "Reverses movement #{id}"),

  // ── Errors (backend → Albanian) ──────────────────────────
  errGeneric: tx("Ndryshimet nuk u ruajtën. Provo përsëri.", "Changes were not saved. Try again."),
  errNetwork: tx(
    "Nuk ka lidhje me serverin. Kontrollo internetin dhe provo përsëri.",
    "Can’t reach the server. Check your connection and try again."
  ),
  errPermission: tx("Nuk ke leje për këtë veprim.", "You don’t have permission for this action."),
  errSession: tx("Sesioni ka skaduar. Hyr përsëri.", "Your session has expired. Sign in again."),
  errNotFound: tx(
    "Produkti nuk u gjet. Mund të jetë fshirë ose nuk i përket kompanisë suaj.",
    "The product wasn’t found. It may have been removed or belong to another company."
  ),
  errVariantMissing: tx(
    "Një variant nuk u gjet më. Rifresko faqen dhe provo përsëri.",
    "A variant no longer exists. Refresh the page and try again."
  ),
  errLocationMissing: tx("Lokacioni nuk u gjet. Zgjidh një lokacion tjetër.", "The location wasn’t found. Choose another."),
  errBrandMissing: tx("Marka e zgjedhur nuk ekziston më.", "The selected brand no longer exists."),
  errTypeMissing: tx("Lloji i zgjedhur nuk ekziston më.", "The selected type no longer exists."),
  errMediaLimit: tx("Një produkt mund të ketë maksimumi {max} foto.", "A product can have at most {max} photos."),
  errMediaIncomplete: tx(
    "Një nga fotot nuk u ngarkua plotësisht. Hiqe dhe ngarkoje përsëri.",
    "One of the photos didn’t upload fully. Remove it and upload it again."
  ),
  errColorGone: tx(
    "Një ngjyrë nuk i përket më këtij produkti. Rifresko faqen.",
    "A colour no longer belongs to this product. Refresh the page."
  ),
  errColorCoverTaken: tx(
    "Një ngjyrë mund të ketë vetëm një kopertinë.",
    "A colour can only have one cover."
  ),
  errColorCoverIneligible: tx(
    "Kjo foto nuk mund të vendoset si kopertinë për këtë ngjyrë, sepse nuk i përket asnjë varianti të saj.",
    "This photo can’t be this colour’s cover because it belongs to none of its variants."
  ),
  errOnePrimary: tx("Vetëm një foto mund të jetë kryesore.", "Only one photo can be the main photo."),
  errOneDefault: tx("Vetëm një variant mund të jetë kryesor.", "Only one variant can be the default."),
  errBarcodeDuplicate: tx("Barkodi „{code}” është shkruar te dy variante.", "Barcode “{code}” is used on two variants."),
  errCodeTaken: tx("Kodi „{code}” përdoret nga një produkt tjetër.", "Code “{code}” is used by another product."),
  errBarcodeTaken: tx("Barkodi „{code}” përdoret nga një produkt tjetër.", "Barcode “{code}” is used by another product."),
  errSkuEmpty: tx("SKU e variantit nuk mund të jetë bosh.", "A variant SKU can’t be empty."),
  errBarcodeEmpty: tx("Barkodi nuk mund të jetë bosh.", "A barcode can’t be empty."),
  errNoChange: tx("Ky rregullim nuk e ndryshon stokun.", "This adjustment doesn’t change stock."),
  errNegative: tx("Stoku përfundimtar nuk mund të jetë negativ.", "Final stock can’t be negative."),
  errBelowReserved: tx(
    "Stoku nuk mund të ndryshohet sepse disa njësi janë të rezervuara. Sasia nuk mund të jetë më e vogël se rezervimet.",
    "Stock can’t be changed because some units are reserved. It can’t go below the reservations."
  ),
  errSerializedAdjust: tx(
    "Rregullimi manual nuk mbështetet për produktet me njësi të serializuara.",
    "Manual adjustment isn’t supported for serialized products."
  ),
  errNotReady: tx("Produkti nuk është gati për publikim:", "The product isn’t ready to publish:"),
  errFileRequired: tx("Zgjidh një foto për ta ngarkuar.", "Choose a photo to upload."),
  errFileTooLarge: tx("Fotoja është më e madhe se 20 MB.", "The photo is larger than 20 MB."),
  errFileType: tx(
    "Ky lloj skedari nuk pranohet. Përdor JPG, PNG ose WEBP.",
    "This file type isn’t accepted. Use JPG, PNG or WEBP."
  ),
  errFileCorrupt: tx(
    "Skedari nuk duket si foto e vlefshme. Mund të jetë i dëmtuar.",
    "The file doesn’t look like a valid photo. It may be damaged."
  ),
  errUpload: tx("Fotoja nuk u ngarkua. Provo përsëri.", "The photo didn’t upload. Try again."),
  errCore: tx("Informacioni i produktit nuk u ruajt.", "Product information was not saved."),
  errVariants: tx("Variantet nuk u ruajtën.", "Variants were not saved."),
  errMedia: tx("Fotot nuk u ruajtën.", "Photos were not saved."),
  errStructure: tx("Struktura nuk u ruajt.", "The structure was not saved."),
  printed: tx("Etiketat u dërguan për printim.", "Labels sent to the printer."),
  noPrintable: tx("Zgjidh të paktën një variant me barkod.", "Select at least one variant with a barcode."),
};

export default productStudioEditTranslations;
